//components/MermaidRenderer.vue
<template>
    <div class="mermaid-container" ref="container"></div>
</template>

<script setup>
import { ref, onMounted, watch, onUnmounted } from 'vue';
import mermaid from 'mermaid';

const props = defineProps({
    diagram: {
        type: String,
        required: true
    }
});

const emit = defineEmits(['nodeDblClick']);
const container = ref(null);

const renderDiagram = async () => {
    if (!container.value) return;
    
    try {
        // Очищаем контейнер
        container.value.innerHTML = props.diagram;
        
        // Конфигурация
        mermaid.initialize({
            startOnLoad: true,
            theme: 'neutral',
            securityLevel: 'loose', // Важно для поддержки HTML
            flowchart: {
                htmlLabels: true,
                curve: 'basis',
                nodeSpacing: 80,
                rankSpacing: 100,
                padding: 30
            }
        });
        
        // Рендерим диаграмму
        await mermaid.run({
            nodes: [container.value]
        });

        // Добавляем обработчики событий к нодам
        setTimeout(() => {
            const nodes = container.value.querySelectorAll('.node');
            nodes.forEach(node => {
                node.addEventListener('dblclick', () => {
                    emit('nodeDblClick', node.id);
                });
            });
        }, 100);
    } catch (error) {
        console.error('Failed to render diagram:', error);
    }
};

onMounted(renderDiagram);
watch(() => props.diagram, renderDiagram);

// Очистка обработчиков при размонтировании
onUnmounted(() => {
    if (container.value) {
        const nodes = container.value.querySelectorAll('.node');
        nodes.forEach(node => {
            node.removeEventListener('dblclick', () => {});
        });
    }
});
</script>

<style scoped>
.mermaid-container {
    width: 100%;
    overflow: auto;
    padding: 20px 0;
}
</style>